module.exports = __webpack_public_path__ + "assets/media/3_seethedetails.23dab3bf.svg";